// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__WFiJz","alertIcon":"ConfirmModal_alertIcon__1ZzO6"};